<template>
  <div class="flex items-center">
    {{ params.value }}
  </div>
</template>

<script>
export default {
  name: 'CellRendererLink',
}
</script>
